import { createSlice } from "@reduxjs/toolkit";
// import patientList from "../../../rtk-apis/patients/patientList";
import addEditAppointment from "@custom/rtk-apis/appointment/addEditAppointment";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addEditAppointmentSlice = createSlice({
  name: "addEditAppointmentSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addEditAppointment.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addEditAppointment.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addEditAppointment.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addEditAppointmentSlice.reducer;
export const { closeModal } = addEditAppointmentSlice.actions;
